import React from 'react'

import type { NarrativeOcgValidationHint } from '../types'
import { hasOcgValidationFindings } from '../utils/issueDetails'
import { NarrativeOcgReferenceActions } from './NarrativeOcgReferenceActions'
import { NarrativeOcgValidationBadges } from './NarrativeOcgValidationBadges'

interface MobileNarrativeOcgFooterActionsProps {
  validationHint?: NarrativeOcgValidationHint
}

export const MobileNarrativeOcgFooterActions = ({
  validationHint,
}: MobileNarrativeOcgFooterActionsProps) => {
  if (
    !validationHint?.visible ||
    validationHint.isLoading ||
    !hasOcgValidationFindings(validationHint)
  )
    return null

  return (
    <div className="mobile-time-entry-ocg-tools">
      <div className="mobile-time-entry-ocg-references">
        <NarrativeOcgReferenceActions
          validationHint={validationHint}
          isMobile
        />
      </div>
      <div className="mobile-time-entry-ocg-badges">
        <NarrativeOcgValidationBadges
          validationHint={validationHint}
          isMobile
        />
      </div>
    </div>
  )
}
